module.exports = __webpack_public_path__ + "static/animation-oss-3caede505d9ea9388c4b780220f32e0d.mp4";